import React from 'react';
import { RichTextContent as RichTextContentType } from 'types/RichTextContent';
import { getComponentForNodeType } from './getComponentForNodeType';

export type RichTextContentProps = {
  node: RichTextContentType;
};

const RichTextContent = ({ node }: RichTextContentProps) => {
  const { content, value } = node;

  return (
    <>
      {content &&
        content.map((childNode, i) => {
          const ChildComponent = getComponentForNodeType(childNode.nodeType);

          if (!ChildComponent) {
            return null;
          }

          return <ChildComponent key={`${childNode.nodeType}-${i}`} node={childNode} />;
        })}

      {value}
    </>
  );
};

export default RichTextContent;
